var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"14px","text-align":"center","margin-top":"10px"}},[_vm._v(" 支付已完成，请返回游戏 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }